import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Storage } from '@ionic/storage';

@Injectable()
export class HttpClient {

  private host: string = 'www.ihsm.uma-csic.es'; //server PRODUCCIÓN
  // private host: string = 'www.ihsm.sombradoble.es'; //servidor DEV
  // private port: string = '8080'; //port
  // private base: string = 'http://localhost' + ':' + this.port; //localhost
  private base: string = 'https://' + this.host;
  private baseUrl: string = this.base + '/api';
  private headers: Headers;
  private http: Http;
  private storage: Storage;
  token;

  constructor(http: Http, storage: Storage) {
    this.http = http;
    this.headers = new Headers();
    this.storage = storage;
  }

  upload(url, files, tags, isProfile, callback) { //need to be named files
    this.storage.ready().then(() => {
      this.storage.get('x-access-token').then(token => {
        if (token) this.headers.set('x-access-token', token);
        var formData: any = new FormData();
        var xhr = new XMLHttpRequest();
        formData.append('tags', tags);
        for (var i = 0; i < files.length; i++) {
          formData.append("files", files[i], files[i].name);
        }
        xhr.onreadystatechange = function () {
          if (xhr.readyState == 4) {
            if (xhr.status == 200) {
              callback(JSON.parse(xhr.response));
            } else {
              callback(false);
            }
          }
        }
        xhr.open("POST", this.baseUrl + url + '?isProfile=' + isProfile + '&token=' + token, true);
        xhr.send(formData);
      });
    });
  }

  get(url, callback) {
    this.storage.ready().then(() => {
      this.storage.get('x-access-token').then(token => {
        if (token) this.headers.set('x-access-token', token);
        this.http.get(this.baseUrl + url, { headers: this.headers }).subscribe(data => {
          console.log('HTTP SUCCESS');
          callback(false, data);
        },
          error => {
            console.log('HTTP ERROR', error);
            callback(true, null);
          });
      });
    });
  }

  post(url, body, callback) {
    this.storage.ready().then(() => {
      this.storage.get('x-access-token').then(token => {
        if (token) this.headers.set('x-access-token', token);
        this.http.post(this.baseUrl + url, body, { headers: this.headers }).subscribe(data => {
          callback(false, data);
        },
          error => {
            callback(true, null);
          });
      });
    });
  }

  put(url, body, callback) {
    this.storage.ready().then(() => {
      this.storage.get('x-access-token').then(token => {
        if (token) this.headers.set('x-access-token', token);
        this.http.put(this.baseUrl + url, body, { headers: this.headers }).subscribe(data => {
          callback(false, data);
        },
          error => {
            callback(true, null);
          });
      });
    });
  }

  delete(url, callback) {
    this.storage.ready().then(() => {
      this.storage.get('x-access-token').then(token => {
        if (token) this.headers.set('x-access-token', token);
        this.http.delete(this.baseUrl + url, { headers: this.headers }).subscribe(data => {
          callback(false, data);
        },
          error => {
            callback(true, null);
          });
      });
    });
  }

  getBaseUrl() {
    return this.base;
  }

  getBaseAPI() {
    return this.baseUrl;
  }
}


// WEBPACK FOOTER //
// ./src/services/HttpClient.ts